import Environment from './environment.png';
import MobileSignal from './communication.png';
import Bolt from './energy.png';
import Lamp from './illumination.png'; 
import Parking from './parking.png';
import Trash from './solid-waste.png';
import Car from './traffic.png';
import Transports from './transportation.png';
import WaterDrop from './water.png';
import Medical from './emergency.png';

export {
    Environment,
    MobileSignal,
    Bolt,
    Lamp,
    Parking,
    Trash,
    Car,
    Transports,
    WaterDrop,
    Medical
};